import { store } from '../../store/store';
import { getFormCategoryName } from './getFormCategoryName';

/**
 * @description formCategoryName is a selector function that retrieves the category name from the store's state.
 * It uses the getFormCategoryName utility function to extract the category name from the current state of the store.
 * If there is an error during this process, it catches the error, logs it to the console, and returns a dummy Selection object.
 * @returns {Selection<string | undefined>} The category name from the store, or a dummy Selection object if there was an error
 */
export const formCategoryName = {
  get: () => {
    const storeInstance = store.getSnapshot();
    return getFormCategoryName(storeInstance.context);
  },
};
